module.exports = ".ck.ck-aria-live-announcer{position:absolute;left:-10000px;top:-10000px}"